/* SiloreParis — core interactions (vanilla, no dependencies) */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('[data-close-nav]').forEach(function (el) {
      el.addEventListener('click', closeMobileNav);
    });
  }

  /* ---------- Search panel ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var inp = searchPanel.querySelector('input'); if (inp) inp.focus(); }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var drawerOverlay = document.querySelector('[data-drawer-overlay]');
  var lastFocus = null;

  function openCart() {
    if (!cartDrawer) return;
    lastFocus = document.activeElement;
    cartDrawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = cartDrawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  window.SiloreCart = { open: openCart, close: closeCart, refresh: refreshCart };

  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openCart(); refreshCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', closeCart);
  });
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMobileNav(); if (searchPanel) searchPanel.classList.remove('is-open'); }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  function formatMoney(cents) {
    var format = window.SiloreMoneyFormat || '₪{{amount}}';
    var patt = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(n) || n == null) n = 0;
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(patt);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return format.replace(patt, value);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var body = document.querySelector('[data-cart-items]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>' + (body.dataset.emptyTitle || 'העגלה ריקה') + '</p><p>' + (body.dataset.emptySub || '') + '</p><a class="btn btn--primary" href="/collections/all">להמשך קנייה</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      html += '<div class="cart-item" data-line-key="' + item.key + '">';
      html += img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div></div>';
      html += '<div><div class="cart-item__title">' + item.product_title + '</div>';
      if (item.variant_title) html += '<div class="cart-item__meta">' + item.variant_title + '</div>';
      html += '<div class="cart-item__meta">כמות: ' + item.quantity + '</div>';
      html += '<button class="cart-item__remove" data-remove="' + item.key + '">הסרה</button></div>';
      html += '<div class="price">' + formatMoney(item.final_line_price) + '</div>';
      html += '</div>';
    });
    body.innerHTML = html;

    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);

    updateFreeShip(cart.total_price);

    body.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-remove'), 0); });
    });
  }

  function updateFreeShip(total) {
    var bar = document.querySelector('[data-free-ship]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) * 100;
    var fill = bar.querySelector('[data-free-ship-fill]');
    var text = bar.querySelector('[data-free-ship-text]');
    if (!threshold) { bar.style.display = 'none'; return; }
    var pct = Math.min(100, (total / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (total >= threshold) text.textContent = bar.dataset.reached || 'משלוח חינם!';
      else text.textContent = (bar.dataset.progress || 'עוד [amount] למשלוח חינם').replace('[amount]', formatMoney(threshold - total));
    }
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '…מוסיף'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); }).then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
        openCart(); refreshCart();
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      });
    });
  });

  /* ---------- Buy now (add then go to checkout) ---------- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var original = btn.innerHTML;
      btn.disabled = true; btn.innerHTML = '…מעבד';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        btn.disabled = false; btn.innerHTML = original;
      });
    });
  });

  /* ---------- Quick add / buy from product cards ---------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-card-add]');
    var buyBtn = e.target.closest('[data-card-buy]');
    if (!addBtn && !buyBtn) return;
    e.preventDefault();
    var btn = addBtn || buyBtn;
    if (btn.disabled) return;
    var id = btn.getAttribute(addBtn ? 'data-card-add' : 'data-card-buy');
    if (!id) return;
    var original = btn.innerHTML;
    btn.disabled = true; btn.innerHTML = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      if (buyBtn) { window.location.href = '/checkout'; return; }
      btn.disabled = false; btn.innerHTML = original;
      openCart(); refreshCart();
    }).catch(function () {
      btn.disabled = false; btn.innerHTML = original;
    });
  });

  /* ---------- Variant picker modal (multi-variant cards) ---------- */
  var vmodal = null;
  function closeVModal() {
    if (!vmodal) return;
    vmodal.classList.remove('is-open');
    var el = vmodal;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, 250);
    vmodal = null;
    document.body.classList.remove('no-scroll');
  }
  function findVariant(data, chosen) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function openVariantModal(data, mode) {
    closeVModal();
    var first = null;
    for (var i = 0; i < data.variants.length; i++) { if (data.variants[i].available) { first = data.variants[i]; break; } }
    var chosen = (first || data.variants[0]).options.slice();

    vmodal = document.createElement('div');
    vmodal.className = 'vmodal';
    vmodal.innerHTML = '<div class="vmodal__overlay" data-vclose></div>'
      + '<div class="vmodal__box" role="dialog" aria-modal="true" aria-label="' + (data.title || '') + '">'
      + '<button class="vmodal__close" type="button" data-vclose aria-label="סגירה">&times;</button>'
      + '<div class="vmodal__head">'
      + (data.image ? '<img class="vmodal__img" src="' + data.image + '" alt="" width="60" height="60">' : '')
      + '<div class="vmodal__title">' + (data.title || '') + '</div>'
      + '</div>'
      + '<div class="vmodal__options"></div>'
      + '<div class="vmodal__price" data-vprice></div>'
      + '<button class="btn btn--primary btn--lg btn--full" type="button" data-vsubmit></button>'
      + '</div>';
    document.body.appendChild(vmodal);
    document.body.classList.add('no-scroll');

    var optWrap = vmodal.querySelector('.vmodal__options');
    data.options.forEach(function (name, oi) {
      var values = [];
      data.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]); });
      var group = document.createElement('div');
      group.className = 'vmodal__group';
      group.innerHTML = '<span class="vmodal__label">' + name + '</span>';
      var pills = document.createElement('div');
      pills.className = 'vmodal__pills';
      values.forEach(function (val) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'vmodal__pill' + (chosen[oi] === val ? ' is-active' : '');
        pill.textContent = val;
        pill.addEventListener('click', function () {
          chosen[oi] = val;
          pills.querySelectorAll('.vmodal__pill').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          sync();
        });
        pills.appendChild(pill);
      });
      group.appendChild(pills);
      optWrap.appendChild(group);
    });

    var priceEl = vmodal.querySelector('[data-vprice]');
    var submit = vmodal.querySelector('[data-vsubmit]');
    function sync() {
      var v = findVariant(data, chosen);
      if (!v) { priceEl.textContent = ''; submit.disabled = true; submit.textContent = 'צירוף לא זמין'; return; }
      priceEl.textContent = formatMoney(v.price);
      if (!v.available) { submit.disabled = true; submit.textContent = 'אזל מהמלאי'; }
      else { submit.disabled = false; submit.textContent = mode === 'buy' ? 'קנה עכשיו' : 'הוסף לעגלה'; }
    }
    sync();

    submit.addEventListener('click', function () {
      var v = findVariant(data, chosen);
      if (!v || !v.available) return;
      submit.disabled = true; submit.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        if (mode === 'buy') { window.location.href = '/checkout'; return; }
        closeVModal(); openCart(); refreshCart();
      }).catch(function () { sync(); });
    });

    vmodal.addEventListener('click', function (e) { if (e.target.closest('[data-vclose]')) closeVModal(); });
    requestAnimationFrame(function () { vmodal.classList.add('is-open'); });
  }
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-card-pick]');
    if (!pick) return;
    e.preventDefault();
    var wrap = pick.closest('.product-card__quickadd');
    var json = wrap && wrap.querySelector('[data-card-data]');
    if (!json) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch (err) { return; }
    openVariantModal(data, pick.getAttribute('data-card-pick'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVModal(); });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.dataset.step === 'down' ? -1 : 1;
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Product variants ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[type="submit"]');

    function selected() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idField.value = match.id;
      if (priceEl && match.price != null) priceEl.innerHTML = formatMoney(match.price);
      if (submit) {
        if (match.available) { submit.disabled = false; submit.dataset.soldout && (submit.innerHTML = submit.dataset.add); }
        else { submit.disabled = true; submit.innerHTML = submit.dataset.soldout || 'אזל מהמלאי'; }
      }
    }
    form.querySelectorAll('[data-option-index] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
  });

  /* ---------- Product gallery slider ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slider = gallery.querySelector('[data-slider]');
    if (!slider) return;
    var slides = Array.prototype.slice.call(slider.children);
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot]'));
    var prev = gallery.querySelector('[data-slide-prev]');
    var next = gallery.querySelector('[data-slide-next]');
    if (slides.length < 2) return;
    function current() { return Math.round(slider.scrollLeft / (slider.clientWidth || 1)); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var c = current();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var t;
    slider.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = trigger.nextElementSibling;
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Header elevation on scroll ---------- */
  var headerEl = document.querySelector('.header');
  if (headerEl) {
    var onHeaderScroll = function () { headerEl.classList.toggle('is-scrolled', window.scrollY > 8); };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !root.classList.contains('a11y-stop-anim')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Init ---------- */
  refreshCart();
})();
